<template>
  <div>
    <el-card class="box-card" body-style="min-height:74vh;">
      <div>
        <el-form :model="ruleForm" ref="ruleForm" label-width="190px" size="small" class="demo-ruleForm">
          <el-form-item label="是否显示：" prop="enable">
            <el-radio-group v-model="ruleForm.enable">
              <el-radio :label="1">开启</el-radio>
              <el-radio :label="0">关闭</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="资质内容：" prop="businessQualificationContent">
            <editor :value="ruleForm.businessQualificationContent" :height="350" v-model="ruleForm.businessQualificationContent"></editor>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="medium" @click="saveBtn">保存</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
import { saveOrUpdateBusinessQualificationConfig, fetchBusinessQualificationConfigDetail } from '@/api/goods'
import Editor from '@/components/Editor.vue'
export default {
  name: 'Banner_add',
  components: {
    Editor
  },
  data () {
    return {
      imgServer: this.$imgServer,
      baseUrl: this.$baseUrl,
      token:this.$token,
      fileList: [],
      ruleForm: {
        enable: '',
        businessQualificationContent:''
      }
    }
  },
  mounted () {
    let that = this
    fetchBusinessQualificationConfigDetail({}).then((res) => {
      if (res.errorCode === '0000') {
        let data = res.data
        that.ruleForm.enable = data.enable
        that.ruleForm.businessQualificationContent = data.businessQualificationContent
      }
    })
  },
  methods: {
    // 返回上一页
    backPage () {
      this.$router.go(-1)
    },
    // 保存操作
    saveBtn () {
      let that = this
      let enable = that.ruleForm.enable
      let businessQualificationContent = that.ruleForm.businessQualificationContent
      if (enable === '') {
        this.$message.error('请选择是否显示')
        return false
      }
      let passData = {
        enable: enable,
        businessQualificationContent:businessQualificationContent
      }
      saveOrUpdateBusinessQualificationConfig(passData).then((res) => {
       that.backDataFun(res)
      })
    },
    backDataFun(res){
      var that = this
      if (res.errorCode === '0000') {
        this.$message({
          message: res.msg,
          type: 'success',
          onClose () {
            that.$router.go(0)
          }
        })
      }
      if (res.errorCode === '1001') {
        this.$message.error(res.msg)
      }
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/goods/BusinessQualification.vue